module.exports = "<div ng-if=\"vm.isRequestCompleted\" class=\"row submitSuccess__message\">\n  <span class=\"icon success-icon col-sm-3\"></span>\n  <p class=\"submitSuccess__icon-font col-sm-6\" translate>{{::vm.requestSuccessMessage}}</p>\n  <span class=\"submitSuccess__name\">\n    {{::vm.additionalData}}\n  </span>\n  <div class=\"submitSuccess__add_another\" translate ng-click=\"vm.returnToOriginalForm()\">{{::vm.addAnotherMessage}}</div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./app/components/submitSuccess/submitSuccess.html
// module id = 442
// module chunks = 1